import type { CurrentUser } from "./useCurrentUser";

type RoleUser = Pick<CurrentUser, "role"> | null | undefined;

export function isClientManager(user: RoleUser): boolean {
  return user?.role === "client";
}

export function isClientStoreUser(user: RoleUser): boolean {
  return user?.role === "client_store";
}

export function isClientLike(user: RoleUser): boolean {
  return isClientManager(user) || isClientStoreUser(user);
}

export function canCompleteClientOrder(user: RoleUser): boolean {
  return user?.role === "client" || user?.role === "super";
}

export function canMutateStores(user: RoleUser): boolean {
  return user?.role === "client" || user?.role === "super";
}

export function canManageStoreAccess(user: RoleUser): boolean {
  return user?.role === "client" || user?.role === "super";
}
